"use client";
import { useState } from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const infoItems = [
  {
    icon: FaPhone,
    title: "PHONE",
    desc: "+ 971 50 798 7470",
    href: "tel:+971507987470",
  },
  {
    icon: FaEnvelope,
    title: "EMAIL",
    desc: "Info@awsbusinessmen.com",
    href: "mailto:Info@awsbusinessmen.com",
  },
  {
    icon: FaMapMarkerAlt,
    title: "ADDRESS",
    desc: "Horizon Towers, Block D, Office 2009 Al Rashidiya 1, Ajman, UAE",
    href: null,
  },
];

export default function ContactSection() {
  const [form, setForm] = useState({
    fname: "",
    lname: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("https://formspree.io/f/xbdnyapg", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        email: form.email,
        name: `${form.fname} ${form.lname}`,
        phone: form.phone,
        message: form.message,
      }),
    });
    if (response.ok) {
      setSubmitted(true);
      setForm({ fname: "", lname: "", email: "", phone: "", message: "" });
      setTimeout(() => setSubmitted(false), 3500);
    }
  };

  return (
    <section className="relative w-full bg-[#FAFAFA] py-12 sm:py-16 lg:py-20 xl:py-24 px-4 md:px-15  overflow-hidden">
      <div className="main-container mx-auto grid gap-10 lg:grid-cols-[1.05fr_0.95fr] items-start">

        {/* ====== LEFT COLUMN ====== */}
        <div className="w-full lg:w-full flex-shrink-0 pt-2.5">
          <span
            className="block text-sm font-medium tracking-widest uppercase mb-3"
            style={{ color: "#E8BF96" }}
          >
            Contact
          </span>

          <h1
            className="font-semibold leading-tight mb-4"
            style={{ fontSize: "clamp(28px, 4vw, 56px)", color: "#1C1D20" }}
          >
            Get in Touch
          </h1>

          <p
            className="mb-8 leading-relaxed"
            style={{ fontSize: "clamp(16px, 1.5vw, 22px)", color: "#1C1D20", fontWeight: 400 }}
          >
            Don&apos;t be afraid! Just say hello
          </p>

          <div className="flex flex-col">
            {infoItems.map((item, i) => {
              const Wrapper = item.href ? "a" : "div";
              const Icon = item.icon;
              return (
                <Wrapper
                  key={i}
                  href={item.href || undefined}
                  className="group flex items-center gap-4 py-3.5 border-b border-gray-200 no-underline transition-all duration-200 cursor-pointer"
                  style={{ borderTop: i === 0 ? "1px solid #e5e7eb" : undefined }}
                >
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 group-hover:bg-[#1C1D20]"
                    style={{ border: "1px solid #E8BF96" }}
                  >
                    <Icon className="text-lg text-[#E8BF96] group-hover:text-white transition-colors duration-200" />
                  </div>

                  <div className="flex flex-col gap-0.5">
                    <span
                      className="text-xs font-medium tracking-widest uppercase"
                      style={{ color: "#1C1D20" }}
                    >
                      {item.title}
                    </span>
                    <span className="text-sm whitespace-pre-line" style={{ color: "#555555" }}>
                      {item.desc}
                    </span>
                  </div>
                </Wrapper>
              );
            })}
          </div>
        </div>

        {/* ====== RIGHT COLUMN — FORM ====== */}
        <div className="w-full flex-shrink-0 mt-10 lg:mt-0">
          <div className="bg-white border border-gray-100 rounded-[32px] p-8 sm:p-10 shadow-xl">
            <form onSubmit={handleSubmit} className="flex flex-col">

              <div className="flex flex-col sm:flex-row gap-0 sm:gap-5">
                <FormGroup label="First name">
                  <input
                    name="fname"
                    type="text"
                    value={form.fname}
                    onChange={handleChange}
                    placeholder="John"
                    style={inputStyle}
                  />
                </FormGroup>
                <FormGroup label="Last name">
                  <input
                    name="lname"
                    type="text"
                    value={form.lname}
                    onChange={handleChange}
                    placeholder="Doe"
                    style={inputStyle}
                  />
                </FormGroup>
              </div>

              <div className="flex flex-col sm:flex-row gap-0 sm:gap-5">
                <FormGroup label="Email">
                  <input
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Info@awsbusinessmen.com"
                    style={inputStyle}
                  />
                </FormGroup>
                <FormGroup label="Phone">
                  <input
                    name="phone"
                    type="tel"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="971 50 798 7470"
                    style={inputStyle}
                  />
                </FormGroup>
              </div>

              <FormGroup label="Message">
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Your message here..."
                  rows={5}
                  style={{
                    ...inputStyle,
                    resize: "vertical",
                    paddingTop: "20px",
                    minHeight: "130px",
                  }}
                />
              </FormGroup>

              <div className="flex flex-col sm:flex-row items-start gap-4 mt-7">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center gap-2.5 rounded-full bg-[#1C1D20] px-8 py-4 text-white text-sm font-semibold transition-all duration-200 hover:bg-[#B8893A] active:scale-95"
                >
                  Send Message →
                </button>

                {submitted && (
                  <p className="text-sm self-center" style={{ color: "#E8BF96" }}>
                    ✓ Message sent successfully!
                  </p>
                )}
              </div>

            </form>
          </div>
        </div>

      </div>
    </section>
  );
}

// -------- Helper Components --------

function FormGroup({ label, children }) {
  return (
    <div className="flex flex-col w-full mb-4" style={{ gap: "6px" }}>
      <label className="text-sm font-medium capitalize pt-2" style={{ color: "#1C1D20" }}>
        {label}
      </label>
      {children}
    </div>
  );
}

// -------- Shared Styles --------

const inputStyle = {
  backgroundColor: "#F7F7F7",
  border: "1px solid #E5E7EB",
  borderRadius: "18px",
  outline: "none",
  padding: "14px 16px",
  fontSize: "14px",
  fontWeight: 400,
  color: "#1C1D20",
  width: "100%",
  fontFamily: "inherit",
  transition: "background 0.15s, border-color 0.15s",
};